import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module table/tablecolumnresize
 */
import { Plugin } from 'ckeditor5/src/core.js';
import TableColumnResizeEditing from './tablecolumnresize/tablecolumnresizeediting.js';
import TableCellWidthEditing from './tablecellwidth/tablecellwidthediting.js';
import '../theme/tablecolumnresize.css';
/**
 * The table column resize feature.
 *
 * It provides the possibility to set the width of each column in a table using a resize handler.
 */
var TableColumnResize = /*#__PURE__*/function (_Plugin) {
  _inherits(TableColumnResize, _Plugin);
  var _super = _createSuper(TableColumnResize);
  function TableColumnResize() {
    _classCallCheck(this, TableColumnResize);
    return _super.apply(this, arguments);
  }
  _createClass(TableColumnResize, null, [{
    key: "requires",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return [TableColumnResizeEditing, TableCellWidthEditing];
    }
    /**
     * @inheritDoc
     */
  }, {
    key: "pluginName",
    get: function get() {
      return 'TableColumnResize';
    }
  }]);
  return TableColumnResize;
}(Plugin);
export { TableColumnResize as default };